import * as React from 'react';

const Box = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 1L18 5.49998V14.5L10 19L2 14.5V5.49998L10 1ZM16.2222 7.2325L10.8889 10.3501V16.4215L16.2222 13.3149V7.2325ZM3.77779 7.28291V13.316L9.11113 16.4215V10.4005L3.77779 7.28291ZM6.65779 4.94019L4.98933 5.91219L9.95733 8.81651L11.6231 7.8427L6.65779 4.94019ZM10 2.99463L8.43913 3.90339L13.4009 6.80319L14.9671 5.88789L10 2.99463Z" fill="currentColor"/>
  </svg>
);

export default Box;
